import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase'; // adjust path if needed
import './BuyCredits.css'; // re-use same style

const CreditCheck = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user_idx } = location.state || {};

  const [ideaCredit, setIdeaCredit] = useState(0);
  const [projectCredit, setProjectCredit] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCredits = async () => {
      if (!user_idx) {
        setIdeaCredit(0);
        setProjectCredit(0);
        setLoading(false);
        return;
      }
      try {
        const docRef = doc(db, 'users', user_idx);
        const snapshot = await getDoc(docRef);
        if (snapshot.exists()) {
          setIdeaCredit(snapshot.data().idea_credit || 0);
          setProjectCredit(snapshot.data().project_credit || 0);
        } else {
          setIdeaCredit(0);
          setProjectCredit(0);
        }
      } catch (err) {
        console.error("Error fetching credits:", err);
        setIdeaCredit(0);
        setProjectCredit(0);
      }
      setLoading(false);
    };

    fetchCredits();
  }, [user_idx]);

  return (
    <div className="buy-credits-container">
      <div className="buy-credits-box">
        <h2>Kredi Durumu</h2>

        {loading ? (
          <p>Yükleniyor...</p>
        ) : (
          <>
            <p>Mevcut Kavram Geliştirme Krediniz: <strong>{ideaCredit}</strong></p>
            <p>Mevcut Proje Krediniz: <strong>{projectCredit}</strong></p>
          </>
        )}

        <div className="buycredit-confirm-buttons">
          <button onClick={() => navigate('/buy_credits', { state: { user_idx } })}>
            Kredi Al
          </button>
          <button onClick={() => navigate('/redeem_code', { state: { user_idx } })}>
            Kredi Kodum Var
          </button>
          <button onClick={() => navigate(-1)}>
            İptal
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreditCheck;
